var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Universal data fetcher/processor to replace the various data-fetching hooks, I hope
import React from 'react';
import { getUrlFor, camelCaseKeys, transformData } from './page-data-utils';
export default function useFetchedData(_a, defaultValue) {
    var { resolveTo = 'json' } = _a, options = __rest(_a, ["resolveTo"]);
    const slug = options.slug;
    const slugPromise = React.useMemo(() => {
        if (!slug) {
            return null;
        }
        return new Promise((resolve) => getUrlFor(slug).then((url) => fetch(url).then(resolve)));
    }, [slug]);
    const url = options.url;
    const urlPromise = React.useMemo(() => {
        if (!url) {
            return null;
        }
        return fetch(url);
    }, [url]);
    const promiseOption = options
        .promise;
    const promise = React.useMemo(() => { var _a; return (_a = slugPromise !== null && slugPromise !== void 0 ? slugPromise : urlPromise) !== null && _a !== void 0 ? _a : promiseOption; }, [slugPromise, urlPromise, promiseOption]);
    const processedPromise = React.useMemo(() => promise
        ? promise
            .then((resp) => resp[resolveTo]())
            .then((rawData) => processRawData(rawData, options))
        : Promise.resolve(defaultValue), [promise, resolveTo] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return usePromise(processedPromise, defaultValue);
}
// This is a common pattern. Should be used throughout the codebase
export function usePromise(promise, defaultValue) {
    const [data, setData] = React.useState(defaultValue);
    React.useEffect(() => {
        promise.then(setData);
    }, [promise]);
    return data;
}
function processRawData(rawData, processing) {
    let returnValue = rawData;
    if (processing.transform) {
        // mutates
        transformData(rawData);
    }
    if (processing.camelCase) {
        returnValue = camelCaseKeys(rawData);
    }
    if (processing.postProcess && returnValue instanceof Array) {
        returnValue = returnValue.map(processing.postProcess);
    }
    return returnValue;
}
